var React = require('react');

function BadgeIconPro (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.46 21.65c-4.68 8.1-9.36 16.2-14.03 24.3 -0.02 0.03-0.04 0.06-0.05 0.09 -0.32 0.6-0.69 1.17-1.48 0.88 -0.83-0.3-0.63-1.03-0.52-1.65 0.36-2.04 0.76-4.07 1.14-6.1 0.68-3.57 1.36-7.15 2.03-10.73 0.06-0.3 0.07-0.62 0.13-1.05 -0.44-0.02-0.82-0.05-1.19-0.05 -2.64 0.01-5.29 0.03-7.93 0.04 -1.55 0-1.92-0.64-1.13-2.01C5.08 17.25 9.76 9.15 14.44 1.05c0.02-0.03 0.04-0.06 0.05-0.09 0.32-0.6 0.69-1.17 1.48-0.88 0.83 0.3 0.63 1.03 0.52 1.65 -0.36 2.04-0.75 4.07-1.14 6.1 -0.68 3.57-1.36 7.15-2.03 10.73 -0.06 0.3-0.07 0.62-0.12 1.05 0.44 0.02 0.82 0.05 1.19 0.05 2.64-0.01 5.29-0.03 7.93-0.04C23.88 19.63 24.25 20.28 23.46 21.65z"}));
}

BadgeIconPro.defaultProps = {"viewBox":"0 0 23.86 47"};

module.exports = BadgeIconPro;

BadgeIconPro.default = BadgeIconPro;
